import React from 'react';
export function Footer() {
  return <footer className="bg-charcoal py-8 border-t border-orange/30 text-center px-4" data-id="element-148" data-mp="32wd2qgad7ltj">
      <div className="max-w-4xl mx-auto" data-id="element-149" data-mp="3gg0zo4mhnzy6">
        <p className="text-white/60 text-sm" data-id="element-150" data-mp="32nukakr5twzs">
          © Hybrid Race Coach Ready 2026 — All Rights Reserved.
        </p>
      </div>
    </footer>;
}